import React from "react";
import VoucherStats from "./VoucherStats";
import { Card, CardBody, CardTitle } from 'reactstrap';

import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../components/DatatablePagination';
const PopularVoucher = ({ statsData, data, labels, revenue, currency, clicks }) => {
    return (<div>
        <div className="row">
            <div className="col-md-12 mb-4">
                <Card>
                    <div style={{ padding: '15px' }}>
                        <div className="float-left float-none-xs">
                            <div className="d-inline-block">
                                <h5 className="d-inline">
                                    Popular Vouchers
                                </h5>
                                <span className="text-muted text-small d-block">
                                    Vouchers Interest and Activity
                                </span>
                            </div>
                        </div>
                    </div>
                    <CardBody>
                        <ReactTable
                            style={{ whiteSpace: 'normal' }}
                            data={data}
                            columns={labels}
                            defaultPageSize={5}
                            filterable={false}
                            showPageJump={true}
                            PaginationComponent={DataTablePagination}
                            showPageSizeOptions={true}
                        />
                    </CardBody>
                </Card>
            </div>
            <div className="mt-4 col-md-12">
                <VoucherStats statsData={statsData} clicks={clicks} currency={currency} revenue={revenue}></VoucherStats>
            </div>
        </div>

    </div >);
};
export default PopularVoucher;